<template>
  <v-alert class="password-requirements" outlined type="info">
    <div class="font-weight-medium mb-2">The password must:</div>
    <div
      v-for="requirement in requirements"
      :key="requirement.key"
      class="d-flex align-center"
      :class="requirement.valid ? 'success--text' : 'grey--text text--darken-2'"
    >
      <v-icon
        small
        class="mr-2"
        :color="requirement.valid ? 'success' : 'grey darken-1'"
      >
        {{ requirement.valid ? "mdi-check-circle" : "mdi-circle-outline" }}
      </v-icon>
      {{ requirement.label }}
    </div>
  </v-alert>
</template>

<script>
import { getPasswordChecks } from "@/utils/passwordPolicy";

export default {
  name: "PasswordRequirements",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    requirements() {
      const checks = getPasswordChecks(this.value);
      return [
        {
          key: "minLength",
          label: "contain at least 8 characters",
          valid: checks.minLength,
        },
        {
          key: "uppercase",
          label: "contain at least one uppercase letter (A-Z)",
          valid: checks.uppercase,
        },
        {
          key: "lowercase",
          label: "contain at least one lowercase letter (a-z)",
          valid: checks.lowercase,
        },
        {
          key: "number",
          label: "contain at least one numeric character (0-9)",
          valid: checks.number,
        },
        {
          key: "special",
          label: "contain at least one special character (!@#$%^&*)",
          valid: checks.special,
        },
      ];
    },
  },
};
</script>
